import { useState } from 'react';
import { emailMap } from './signUpFormConf';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import PolicyCheck from '@/components/PolicyCheck';

export default function Subscribe() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const [popupVisible, setPopupVisible] = useState(false);
    const { t } = useLang('wave2portableairconditioner');
    const emailConf = emailMap[locale] || emailMap.us;

    const showPolicyCheck = ['uk', 'eu', 'es', 'de', 'fr', 'it', 'au'].includes(locale);
    const [checked, setChecked] = useState(!showPolicyCheck);

    const onCheckChange = (e: any) => {
        if (e.target.checked) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    };

    // ttd事件us/ca埋点
    const handleTTDLog = () => {
        if (!['us', 'ca'].includes(locale)) return;
        const img = document.createElement('img');
        img.src = `https://insight.adsrvr.org/track/pxl/?adv=p9kn8wu&ct=0:llez7u2&fmt=3&hash=${Math.random()}`;
        img.style.display = 'none';
        document.body.append(img);
    };

    return (
        <div className={`${css.Subscribe} subscribe-wrapper`}>
            {emailConf?.type === 'klaviyo' && (
                <Klaviyo
                    extra_properties={{
                        custom_source: emailConf.source,
                        $source: emailConf.source,
                        $method_type: 'Klaviyo Form',
                        $consent_version: 'Embed default text',
                        $consent_form_id: emailConf.consent_form_id,
                    }}
                    successCallback={() => {
                        setPopupVisible(true);
                        try {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('teaser.subscribe'),
                                product_name: 'EcoFlow WAVE2',
                                status: 'success',
                            });
                            handleTTDLog();
                            window?.fbq && window?.fbq('track', 'Lead');
                        } catch (e) {
                            console.error(e);
                        }
                    }}
                    errorCallback={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: t('teaser.subscribe'),
                            product_name: 'EcoFlow WAVE2',
                            status: 'fail',
                        });
                    }}
                >
                    <KlaviyoView list_id={emailConf.list_id} submitText={t('teaser.subscribe')} placeholder={t('teaser.placeholder')} disabled={!checked} />
                </Klaviyo>
            )}
            {emailConf.type === 'mailchimp' && (
                <>
                    <Mailchimp
                        successCallback={() => {
                            setPopupVisible(true);
                            try {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_submit',
                                    button_name: t('teaser.subscribe'),
                                    product_name: 'EcoFlow WAVE2',
                                    status: 'success',
                                });
                                window?.fbq('track', 'Lead');
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        errorCallback={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('teaser.subscribe'),
                                product_name: 'EcoFlow WAVE2',
                                status: 'fail',
                            });
                        }}
                    >
                        <MailchimpView
                            action={emailConf.action}
                            extraFields={emailConf.extraFields}
                            submitText={t('teaser.subscribe')}
                            placeholder={t('teaser.placeholder')}
                            disabled={!checked}
                        />
                    </Mailchimp>
                </>
            )}
            {showPolicyCheck && (
                <PolicyCheck
                    terms={locale === 'au' ? 'https://au.ecoflow.com/pages/terms-of-use-1' : ''}
                    policy={locale === 'au' ? 'https://au.ecoflow.com/pages/privacy-policy' : ''}
                    onCheckChange={onCheckChange}
                />
            )}
            {['us', 'ca'].includes(locale) && <p className="email-note">{t('teaser.email_note')}</p>}
            <Popup
                visible={popupVisible}
                title={t('teaser.popup_title')}
                content={t.rich('teaser.popup_content')}
                buttonText={t('teaser.popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
                theme="black"
            />
        </div>
    );
}
